export const formatPercentage = (percent: number, precision = 0): string =>
  (percent * 100).toFixed(precision) + '%'
